<template>
  <div class="home">
    <router-link
        v-for="name in spreadsheetsName" :key="name"
        :to="'/form/' + name">Vers la commande {{name}}</router-link> |
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: 'Home',
  components: {
  },
  computed: {
    ...mapGetters([
      'spreadsheetsName',
    ])
  }
}
</script>
